import { useState } from "react";

const useFilteredPagination = (
	data,
	setActions,
	setItemId,
	setOpen,
	setDeleteOpen,
	currentPage,
	setMoveRefundOpen,
	handleCurrentPageChange,
	setToggleMenu
) => {
	const [filters, setFilters] = useState({
		combinedFilter: "",
	});

	const handleFilterChange = (e) => {
		const { name, value } = e.target;
		setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
		handleCurrentPageChange(1);
	};

	const filterData = (item) => {
		const filterTerms = filters.combinedFilter
			.toLowerCase()
			.split(",")
			.map((term) => term.trim());

		return filterTerms?.some((term) =>
			Object.values(item)?.some((val) =>
				String(val).toLowerCase().includes(term)
			)
		);
	};

	// Filter the original data first
	const filteredData = data?.filter(filterData);

	// Calculate the total number of pages based on filtered data
	const totalData = filteredData?.length;

	const handlePageChange = (page) => {
		handleCurrentPageChange(page);
	};

	const toggleActions = (userId) =>
		setActions((prevActions) => ({
			...Object.fromEntries(
				Object.entries(prevActions).map(([id, value]) => [id, false])
			),
			[userId]: !prevActions[userId],
		}));

	const handelFindDataByID = (dataId, string) => {
		const data = filteredData.find((data) => data._id === dataId);
		if (data) {
			setItemId(data);
			if (string === "Update") {
				setOpen(true);
				setToggleMenu(false);
			}
			else if (string === "move-to-refund") {
				setMoveRefundOpen(true);
			} else {
				setDeleteOpen(true);
			}
		}
	};
	return {
		filters,
		handleFilterChange,
		currentPage,
		handlePageChange,
		displayedData: filteredData,
		totalData,
		toggleActions,
		handelFindDataByID,
	};
};

export default useFilteredPagination;
